import axios from "@/plugins/axios";
import { getApiUrl } from "@/services/_apiUrl";

const apiUrl = getApiUrl();

export function fetchWebhooks(params = {}) {
  return axios.get(apiUrl.webhooks.GET.LIST, { params });
}

export function fetchWebhookById(webhookId) {
  return axios.get(`${apiUrl.webhooks.GET.DETAIL}${webhookId}/`);
}

export function createWebhook(data) {
  return axios.post(apiUrl.webhooks.POST, data);
}

export function updateWebhook(webhookId, data) {
  return axios.put(`${apiUrl.webhooks.PUT}${webhookId}`, data);
}

export function deleteWebhook(webhookId) {
  return axios.delete(`${apiUrl.webhooks.DELETE}${webhookId}`);
}

export function fetchWebhookEvents(params = {}) {
  return axios.get(apiUrl.webhookEvents.GET.LIST, { params });
}

export function fetchWebhookEventById(eventId) {
  return axios.get(`${apiUrl.webhookEvents.GET.DETAIL}${eventId}`);
}

export function retryWebhookEvent(eventId) {
  return axios.post(`${apiUrl.webhookEvents.POST.RETRY}${eventId}/retry`);
}
